export default {
  dev: process.env.NODE_ENV === 'development',
}
